import { gql } from "@apollo/client";

export const GET_PAYMENT_TAXES = gql`
query Data($where: PaymentTaxInput) {
    paymentTaxes(where: $where) {
      data {
        tag
        taxPercent
        taxPrice
        partner
      }
    }
  }
`;

export const GET_PAYMENT_TAXE = gql`
query Data {
    paymentSupportCurrencyLAKTax {
      data {
        tag
        taxPercent
        taxPrice
        minPrice
        maxPrice
        partner
        index
      }
      total
    }
  }
`;

